import React from 'react';
import { NavLink } from 'react-router-dom';

const loginAction = props => {
	return (
		
		<div className="loginBox_right" style={{"display":"none"}}>
	        <ul>
	            <li>
					{/*<a href="#" className="crm_Login active" id="view-signin">*/}
					<NavLink className="crm_Login" to="/login">
						<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="22px" height="22px" viewBox="0 0 26 26" enableBackground="new 0 0 26 26" >
							<g> 
								<path fill="#B0BEC5" d="M20.209,24.452H6.437c-0.817,0.005-1.59-0.37-2.097-1.011c-0.493-0.618-0.674-1.427-0.493-2.196 c1.239-5.232,6.486-8.469,11.718-7.229c3.584,0.849,6.383,3.648,7.231,7.229c0.181,0.77-0.001,1.578-0.495,2.196 C21.796,24.082,21.023,24.455,20.209,24.452z M13.32,15.691C9.698,15.674,6.543,18.16,5.72,21.69 c-0.043,0.192,0.003,0.393,0.126,0.548c0.144,0.177,0.362,0.28,0.591,0.275h13.772c0.221,0,0.433-0.103,0.57-0.275 c0.124-0.154,0.172-0.355,0.129-0.548C20.084,18.168,16.937,15.679,13.32,15.691z"/>
								<path fill="#B0BEC5" fillOpacity="0.5" d="M13.32,11.881c-2.854,0-5.167-2.313-5.167-5.167c0-2.854,2.313-5.168,5.167-5.168 c2.854,0,5.168,2.313,5.168,5.168l0,0C18.487,9.568,16.175,11.88,13.32,11.881z M13.32,3.488c-1.782,0-3.226,1.444-3.226,3.227 c0,1.782,1.443,3.226,3.226,3.226c1.781,0,3.227-1.444,3.227-3.226l0,0C16.545,4.934,15.102,3.491,13.32,3.488z"/>
							</g>
						</svg>	
	              		<span> Login </span>
		            {/*</a>*/}
		            </NavLink>
	            </li>

	            <li>
	            	<NavLink className="crm_Signup svgIconFill" to="/signup">
						<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="22px" height="22px" viewBox="0 0 26 26" enableBackground="new 0 0 26 26">
							<g>
								<path fill="#B0BEC5" d="M23.106,23.537H10.66c-0.799,0.005-1.555-0.359-2.047-0.989c-0.483-0.604-0.662-1.396-0.485-2.149 c1.136-4.831,5.972-7.825,10.802-6.689c3.318,0.78,5.908,3.37,6.689,6.689c0.179,0.753-0.001,1.547-0.486,2.149 C24.645,23.172,23.897,23.536,23.106,23.537z M16.875,15.628c-3.179-0.021-5.95,2.162-6.67,5.26 c-0.028,0.114,0.001,0.233,0.077,0.322c0.084,0.115,0.219,0.182,0.361,0.178h12.463c0.142-0.003,0.273-0.067,0.362-0.178 c0.072-0.091,0.1-0.208,0.077-0.322C22.822,17.792,20.054,15.608,16.875,15.628z"/>
								<path fill="#B0BEC5" fillOpacity="0.5" d="M16.875,12.192c-2.687,0-4.864-2.178-4.864-4.864c0-2.687,2.178-4.864,4.864-4.864 s4.865,2.178,4.865,4.864C21.737,10.013,19.562,12.189,16.875,12.192z M16.875,4.614c-1.499,0-2.715,1.215-2.715,2.714 c0,1.499,1.216,2.714,2.715,2.714c1.498,0,2.714-1.215,2.714-2.714C19.586,5.83,18.373,4.616,16.875,4.614z"/>
								<path fill="#B0BEC5" d="M8.699,8.402H1.388c-0.594,0-1.075-0.481-1.075-1.075s0.481-1.075,1.075-1.075h7.312 c0.594,0,1.075,0.481,1.075,1.075S9.293,8.402,8.699,8.402z"/>
								<path fill="#B0BEC5" d="M5.043,12.059c-0.594,0-1.075-0.482-1.075-1.076V3.672c0-0.594,0.481-1.076,1.075-1.076 s1.075,0.481,1.075,1.076v7.311C6.119,11.576,5.637,12.059,5.043,12.059z"/>
							</g>
						</svg>
	                	<span> Sign up </span>
	            	</NavLink>
	            </li>
	        </ul>
	    </div>
	)
}

export default loginAction;